import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import './index.css'
import App from './App.jsx'
import axios from 'axios'
import PreviewPage from './pages/PreviewPage.jsx'

const encoded = btoa(import.meta.env.VITE_USERNAME + ':' + import.meta.env.VITE_PASSWORD).toString('base64');

axios.defaults.baseURL = import.meta.env.VITE_API_URL;
axios.defaults.headers.common['Authorization'] = 'Basic ' + encoded;
axios.defaults.headers.post['Content-Type'] = 'application/form-data';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/121" replace />} />
        <Route path="/:clubId" element={<App />} />
        <Route path="/preview" element={<PreviewPage />} />
      </Routes>
    </Router>
  </StrictMode>,
)
